import Api from '@/data/Api.ts';
import StringUtils from '@/infrastructure/support/utils/StringUtils.ts';

const API_URL_PUT_YIELD_PROMISE_STATUS =
  '/companies/{0}/plants/{1}/promise-status/{2}';
const API_URL_CREATE_GAP_FILL =
  '/companies/{0}/plants/{1}/promise-statuses/{2}/gap-fills';
const API_URL_DELETE_GAP_FILL =
  '/companies/{0}/plants/{1}/promise-statuses/{2}/gap-fills/{3}';

export default class YieldPromiseStatusApi extends Api {
  /**
   * @param companyId The associated company id.
   * @param plantId The plant id to update.
   * @param yieldPromiseId The associated yield promise id.
   * @param payload The payload to send with the request.
   */
  updateYieldPromise(
    companyId: number,
    plantId: number,
    yieldPromiseId: number,
    payload: {},
  ): Promise<any> {
    const url: string = StringUtils.stringFormat(
      API_URL_PUT_YIELD_PROMISE_STATUS,
      [companyId, plantId, yieldPromiseId],
    );
    return this.standardPut(url, payload);
  }

  createGapFill(
    companyId: number,
    plantId: number,
    yieldPromiseId: number,
    payload: {},
  ): Promise<any> {
    const url: string = StringUtils.stringFormat(API_URL_CREATE_GAP_FILL, [
      companyId,
      plantId,
      yieldPromiseId,
    ]);
    return this.standardPost(url, payload);
  }

  deleteGapFill(
    companyId: number,
    plantId: number,
    yieldPromiseId: number,
    gapFillId: number,
  ): Promise<any> {
    const url: string = StringUtils.stringFormat(API_URL_DELETE_GAP_FILL, [
      companyId,
      plantId,
      yieldPromiseId,
      gapFillId,
    ]);
    return this.standardDelete(url);
  }
}
